import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplyProcessApi from 'api/curo/ApplyProcessApi';
import { ApplyProcessActionTypes } from 'enums/curo/ApplyProcessActionTypes';

export const createExistingApplicationCheckThunk = (api: ApplyProcessApi) =>
  createAsyncThunk(
    ApplyProcessActionTypes.CheckExistingApplication,
    async ({ borrowerPersonalIdNumber }: { borrowerPersonalIdNumber: string }) => {
      const response = await api.existingApplicationCheck(borrowerPersonalIdNumber);

      return response;
    },
  );
